import ChartTableContent from './chart_table_content.js';
import ReportChart from './report_chart.js';

var chartOptions, rating_chart_table;

chartOptions = {
  legend: {
    display: false
  },
  layout: {
    padding: {
      right: 50
    }
  },
  tooltips: {
    enabled: false
  },
  scales: {
    xAxes: [
      {
        display: false,
        ticks: {
          beginAtZero: true
        }
      }
    ],
    yAxes: [
      {
        barThickness: 20,
        interval: 20,
        gridLines: {
          display: false
        }
      }
    ]
  },
  hover: {
    animationDuration: 0
  }
};

export default rating_chart_table = Vue.extend({
  components: {
    'chart-table-content': ChartTableContent,
    'report-chart': ReportChart
  },

  props: {
    field: {
      type: Object,
      default: null
    }
  },

  data: function() {
    return {
      detailOptions: [],
      chartType: 'horizontalBar',
      chartOptions: chartOptions,
      sortType: 'normal'
    };
  },

  template: `
    <chart-table-content :title='field.title' :fieldType='field.type' @toggleChangeSort="changeSort">
      <template slot="chart-data-counts">
        <div class="text-small ml-6 gray-text">{{ sortOptions.length }}条数据</div>
      </template>

      <template slot="chart-content">
        <div class="chart-content">
          <div class="chart-show">
            <report-chart :chartData='chartData'
                          :chartType='chartType'
                          :chartOptions='chartOptions' />
          </div>
        </div>
      </template>

      <template slot="chart-data-table-tbody">
        <tr v-for="option in sortOptions" :key='option.id'>
          <td>{{ option.value }}</td>
          <td>{{ option.count }}</td>
          <td>{{ _getPercentage(option.count) + '%' }}</td>
        </tr>
      </template>
    </chart-table-content>
  `,

  computed: {
    sortOptions: function() {
      switch (this.sortType) {
        case 'asc':
          return _.sortBy(this.detailOptions, function(item) {
            return item.count;
          });
        case 'desc':
          return _.sortBy(this.detailOptions, function(item) {
            return -item.count;
          });
        default:
          return this.detailOptions;
      }
    },

    chartData: function() {
      return _.reduce(this.sortOptions, (memo, option) => {
        memo.labels.push(option.value);
        memo.data.push(this._getPercentage(option.count));
        return memo;
      }, {
        labels: [],
        data: []
      });
    }
  },

  created: function() {
    return this._generateDetailOptions();
  },

  methods: {
    changeSort: function() {
      return this.sortType = (function() {
        switch (this.sortType) {
          case 'asc':
            return 'desc';
          case 'desc':
            return 'normal';
          case 'normal':
            return 'asc';
        }
      }).call(this);
    },

    _generateDetailOptions: function() {
      return this.detailOptions = _.map(this.field.details, function(value, item) {
        return {
          value: item,
          count: value
        };
      });
    },

    _getPercentage: function(selected_count) {
      return Number((selected_count / this.field.total_selected_count) * 100).toFixed(1);
    }
  }
});
